<template>
  <div>
    <br />
    <vs-card style="border-radius: 20px">
      <div class="mt-2 mb-2">
        <vs-row id="center">
          <h3 class="headerText">Setup and Configure Work Requests</h3>
          <vs-spacer />
          <vs-button
            v-b-modal.modal-createCustomize
            color="success"
            type="filled"
            icon="add"
            style="border-radius: 20px"
            >Create a Custom Form</vs-button
          >
        </vs-row>
      </div>
      <vs-table
        search
        :data="users"
        style="background-color: #f2f3f4; border-radius: 20px"
        pagination
        max-items="5"
      >
        <template slot="thead">
          <vs-th id="noWrap" sort-key="email">
            Name<span><vs-icon icon="unfold_more" size="13px"></vs-icon></span>
          </vs-th>
          <vs-th id="noWrap"> Work Request Portal URL (no login needed) </vs-th>
          <vs-th id="noWrap"> Configuration </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].template_name">
              <p class="ml-2 mt-2 pt-1">{{ data[indextr].template_name }}</p>
            </vs-td>

            <vs-td :data="data[indextr].username">
              <vs-row id="center" class="ml-2">
                <a :href="value">
                  {{ value }}
                </a>
                <router-link
                  target="_blank"
                  :to="'Request/' + data[indextr].uuid"
                  class="mt-2 pt-1"
                  >https://demo.sentenance.com//#/Request/{{
                    data[indextr].uuid
                  }}</router-link
                >
                <vs-button
                  radius
                  class="ml-1"
                  color="success"
                  type="flat"
                  icon="dashboard"
                  v-b-modal.modal-QR
                  @click="a = data[indextr]"
                ></vs-button>
              </vs-row>
            </vs-td>

            <vs-td>
              <a v-b-modal.modal-Customize class="ml-2">Customize</a>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-card>

    <b-modal
      id="modal-Customize"
      size="lg"
      ref="modal-Customize"
      title="Customize the Work Request "
    >
      <divSetupWorkReq
        :itemCustom="itemCustom"
        :basicSettings="basicSettings"
        :locationList="locationList"
      />

      <template #modal-footer>
        <vs-button
          @click="saveTempRequest(basicSettings)"
          class="brdbtn"
          color="success"
          type="filled"
          >Submit</vs-button
        >
        <vs-button class="brdbtn" color="dark" type="flat" @click="cancelEdit"
          >Close</vs-button
        >
      </template>
    </b-modal>

    <b-modal
      id="modal-createCustomize"
      size="lg"
      ref="modal-createCustomize"
      title="Create Customize the Work Request "
    >
      <divcreateWorkReq
        :itemCustom="itemnewCustom"
        :basicSettings="newSettings"
        :locationList="locationList"
      />

      <template #modal-footer>
        <vs-button
          @click="savenewTempRequest(newSettings)"
          class="brdbtn"
          color="success"
          type="filled"
          >Submit</vs-button
        >
        <vs-button class="brdbtn" color="dark" type="flat" @click="cancelEdit"
          >Close</vs-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
import divSetupWorkReq from "../../views/components/dashboard/WorkRequest/Modal/divSetupWorkReq.vue";
import divcreateWorkReq from "../../views/components/dashboard/WorkRequest/Modal/divCreateWorkReq.vue";
export default {
  components: {
    divSetupWorkReq,
    divcreateWorkReq,
  },
  data() {
    return {
      locationList: [],
      users: [
        {
          template_name: "test",
          uuid: "752c4e264c78",
        },
        {
          template_name: "test2",
          uuid: "752c4e264c78",
        },
        {
          template_name: "test3",
          uuid: "752c4e264c78",
        },
        {
          template_name: "test4",
          uuid: "752c4e264c78",
        },
      ],
      newSettings: {
        titleWR: { text: "Title", value: "" },
        templatename: "",
        priority: { text: "Priority", value: "" },
        nameRequester: { text: "Name", value: "" },
        phoneRequester: { text: "Phone Number", value: "" },
        emailRequester: { text: "Email", value: "" },
        location: { text: "Related asset", hint: "", value: "" },
        compleDate: { text: "Completion Date", value: "" },
        attachPicture: { text: "Attach a picture", value: "" },
        titleAdvan: { text: "IT", value: "" },
        description: { text: "Description of the Problem", value: "" },
        customField: [{ name: "", value: "" }],
        customDropdown: [{ name: "", value: "", options: [{ value: "" }] }],
        customTag: "",
        logo: [],
      },
      newSettings2: {
        // assignedTo: { text: "Assigned To", value: "" },
        titleWR: { text: "Title", value: "" },
        templatename: "",
        priority: { text: "Priority", value: "" },
        nameRequester: { text: "Name", value: "" },
        phoneRequester: { text: "Phone Number", value: "" },
        emailRequester: { text: "Email", value: "" },
        location: { text: "Related asset", hint: "", value: "" },
        compleDate: { text: "Completion Date", value: "" },
        attachPicture: { text: "Attach a picture", value: "" },
        titleAdvan: { text: "IT", value: "" },
        description: { text: "Description of the Problem", value: "" },
        customField: [{ name: "", value: "" }],
        customDropdown: [{ name: "", value: "", options: [{ value: "" }] }],
        customTag: "",
        logo: [],
      },
    };
  },
  mounted() {
    this.$API.get(`workrequest/customform`).then((result) => {
      console.log(result.data);
      this.users = result.data;
      console.log(this.users);
    });
    this.$API.get("location/user").then((result) => {
      console.log(result);
      this.locationList.push(result.data[0].list.value);
    });
  },
  methods: {
    savenewTempRequest(item) {
      console.log(item);
      //   let dataResult = [];
      //   this.newSettings.forEach(element => {
      //     element.value =  ""
      //     if(key!="templatename"){
      //        obj[key].value = ""
      //     }
      //    else if(key == "templatename") {obj[key] = ""}
      //   });
      //   for (let key in this.newSettings) {
      //     if (key != "templatename") this.newSettingsbj[key].value = "";
      //     else if (key == "templatename") this.newSettings[key] = "";
      //   }
      //   console.log(this.newSettings)
      let body = { template: item };
      this.$API.post(`workrequest/customform`, body).then((result) => {
        console.log(result);
        this.newSettings = this.newSettings2;
        this.users.push(result.data[0]);
        this.$refs["modal-createCustomize"].hide();
      });
    },
  },
};
</script>

<style></style>
